import React, { ForwardedRef, forwardRef } from 'react';
import { ModalWithTrash, Title } from '@investoro/core';
import styled from 'styled-components';

const DeleteAccountSection = styled.div`
    h1 {
        padding: 10px;
    }
`;

const DeleteAccountContainer = styled.div`
    padding: 32px 31px;
    border-radius: var(--box-border-radius);
    background: var(--color-white);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 10px;
    margin-bottom: 60px;
`;

const ModalTrashWrapper = styled.div`
    border: 1px solid var(--color-warning);
    padding: 8px 16px;
    border-radius: var(--border-radius);
`;

interface DeleteAccountProperties {
    onDeleteAccount: () => void;
    isDark: boolean;
}

const DeleteAccount = forwardRef<HTMLDivElement, DeleteAccountProperties>(({ onDeleteAccount, isDark }, ref: ForwardedRef<HTMLDivElement>) => {
    return (
        <DeleteAccountSection ref={ref}>
            <Title>Usuń konto</Title>
            <DeleteAccountContainer>
                <p style={{ marginBottom: '20px', color: 'var(--color-text-secondary)' }}>
                    ⚠️ Ta operacja jest nieodwracalna. Wszystkie Twoje dane zostaną trwale usunięte.
                </p>
                <ModalTrashWrapper>
                    <ModalWithTrash
                        onChange={onDeleteAccount}
                        filter="Twoje konto zostanie trwale usunięte"
                        title="Czy na pewno chcesz usunąć konto?"
                        description="Ta operacja jest nieodwracalna. Utracisz dostęp do wszystkich swoich danych, filtrów, zamówień i subskrypcji. Wszystkie informacje zostaną trwale usunięte z naszych serwerów."
                        iconText="Usuń konto"
                        isDarkMode={isDark}
                    />
                </ModalTrashWrapper>

            </DeleteAccountContainer>
        </DeleteAccountSection>
    );
});

export default DeleteAccount;
